import { Inventory } from "@mui/icons-material";

export default {
  API_BASEPATH_STAGING: "",
  API_BASEPATH_PROD: "",
  //API_BASEPATH: "",
  apis: {
    admin: {
      LOGIN: "/user-service/admin/authenticate",
      VERIFY_OTP: "/user-service/admin/verify-otp",
      RESEND_OTP: "/user-service/admin/resend-otp",
      FORGET_PASSWORD_OTP: "/user-service/admin/forget-password/otp",
      STATE_LIST: "/user-service/admin/state/list",
      CITY_LIST: "/user-service/admin/city/list",
      MERCHANT_LIST: "/user-service/admin/merchant/listing",
      NCMC_LIST:"/user-service/admin/merchant/ncmc/listing",
      FOS_LIST:"/user-service/admin/fos-agent/listing",
      FOS_AGENT_MANAGE: "/user-service/api/fos-agent/fos-agent/manage",
      MERCHANT_LIST_VPA: "/user-service/admin/merchant/detail/listing",
      MERCHANT_VPA_DETAILS: "/user-service/admin/merchant/vpa/details",
      WEBHOOK_TYPE:"/api-service/user/webhook-types",
      // USER_LIST: "/user-service/admin/user-list",
      USER_LIST: "/user-service/admin/v1/user-list",
      CPV_LISTING:"/user-service/admin/cpv-reinitiate/listing",
      SOCIETY_LIST: "/api-service/user/api/societiesList",
      SAVE_ORG_LOGO: "/user-service/dashboard/upload/logo",
      SAVE_ORG_THEME: "/user-service/dashboard/theme/select",
      FETCH_ORG_LOGO: "/user-service/dashboard/fetch/logo",
      FETCH_THEMES: "/user-service/dashboard/fetch/themes",
      FETCH_ORG_THEME: "/user-service/dashboard/fetch-org/theme",
      OFFLINE_TRANSACTION_REPORT:"/payment/prepaid/card/API/v1/offline/txn/listing",
      FETCH_CHARGES: "/payment/partner/charge/config-list/org",
      FETCH_TRANSACTION_CHARGES: "/payment/partner/charge/config-list",
      UPDATE_STATUS_TRANSACTION_CHARGES: "/payment/partner/charge/config/status",
      UPDATE_CASH_BACK: "/api-service/user/update/society-cashback",
      PROG_LIST: "/api-service/user/api/programManagerList",
      TID_WHITELISTING: "/payment/org-tid-details/",
      CREATE_SOCIETY: "/api-service/user/api/create",
      CREATE_PROGRAM: "/api-service/user/api/add/programManager",
      SOC_WALLET_BALANCE: "/api-service/user/org_wallet-balance",
      LEDGER_DETAILS: "/api-service/user/transactions",
      STATUS_UPDATE: "/api-service/bank/account/status/update",
      ADD_BANK: "/api-service/bank/add-to-org",
      UPDATE_BANK:"/api-service/bank/update/bank-account",
      ADD_WHITELIST: "/api-service/bank/whitelist-org",
      BANK_DETAILS: "/api-service/bank/bank-account",
      WHITELIST_DETAILS: "/api-service/bank/org/whitelisted-accounts",
      ADD_OTHER: "/api-service/user/addIpWebhook",
      WEBHOOK_ONLY:"/api-service/user/addWebhookByType",
      OTHER_DETAILS: "/api-service/user/getIpWebhook",
      GET_CASHBACK:"/api-service/user/getCashback",
      UPDATE_CASHBACK:"/api-service/user/update/society-cashbacks",
      CASH_BACK: "/user-service/admin/add/cashBackUser",
      BASIC_USER_LIST: "/user-service/admin/merchant/minkyc/listing",
      UPDATE_STATUS: "/user-service/admin/update/status",
      UPDATE_ADMIN_DETAILS: "/user-service/admin/update/details",
      FOGOT_PASSWORD: "/user-service/admin/reset-password",
      GET_PAYMENT_LISTS: "/reporting-service/admin/transaction/listing",
      GET_SETTLEMENT_LISTS: "/reporting-service/admin/settlement/reports",
      GET_REFUND_LISTS: "/payment/payment/get-payu-transaction-detail",
      INITIATE_REFUND: "/payment/payment/initiate-refund",
      GET_REFUND_STATUS: "/payment/payment/fetch-refund-status",
      // SEND_NOTIFICATION: "/reporting-service/notification/upload",
      SEND_NOTIFICATION: "/reporting-service/notification/v2/notification/schedule",
      PAYMENT_MODES: "/payment/admin/configuration/transaction/type",
      BANK_LIST: "/payment/admin/types/bank",
      BANKS_LIST: "/payment/user/bank/list",
      // BALANCE_INFORMANTION: "/payment/payment/user-wallet",
      BALANCE_INFORMANTION: "/payment/payment/user-wallet-v2",
      PAYMENT_MODE_LIST: "/payment/admin/types/payment/methods",
      SAVE_ROLE_AND_PAYMENT_MODE: "/payment/admin/configuration/role",
      UPDATE_ROLE_AND_PAYMENT_MODE: "/payment/admin/configuration/update/role",
      ROLE_INFO: "/payment/admin/configuration/role/info",
      ADD_LIMIT: "/payment/admin/configuration/limits",
      LIST_LIMIT: "/payment/admin/configuration/list/limit",
      DELETE_LIMIT: "/payment/admin/configuration/delete/limit",
      UPDATE_LIMIT: "/payment/admin/configuration/update/limit",
      LIST_LIMIT_FREQUENCY: "/payment/admin/types/limit/frequency",
      PAYMENT_SETTING_LIST: "/payment/admin/configuration/all/info",
      PAYMENT_SETTING_LIST_ROLE: "/payment/admin/configuration/list/role",
      FEES_RATE: "/payment/admin/types/fee/rate",
      SUBMIT_FEES: "/payment/admin/configuration/fee",
      LIST_FEES: "/payment/admin/configuration/list/fee",
      UPDATE_FEES: "/payment/admin/configuration/update/fee",
      DELETE_FEES: "/payment/admin/configuration/delete/fee",
      MANAGE_CARD_LIST: "/payment/admin/prepaid/card/user/list",
      MANAGE_CARD_LOCK: "/payment/admin/prepaid/card/lock",
      MANAGE_CARD_UNLOCK: "/payment/admin/prepaid/card/unlock",
      MANAGE_CARD_BLOCK: "/payment/admin/prepaid/card/block",
      MANAGE_CARD_REPLACE: "/payment/prepaid/card/replace",
      ADD_ADMIN_CONFIGURATION: "/payment/admin/configuration/add",
      GET_CASHBACK_CONFIG:"/payment/app/configuration/get/upi-cashback-toggle",
      UPDATE_CASHBACK_CONFIG:"/payment/app/configuration/update/upi-cashback-toggle",
      DASHBOARD_DETAILS: "/reporting-service/admin/dashboard/details",
      DASHBOARD_GRAPH: "/reporting-service/admin/dashboard/graph",
      TRANSACTION_GRAPH: "/reporting-service/admin/dashboard/transaction/details",
      DASHBOARD_TNC_RECORD: "/reporting-service/admin/dashboard/transaction/record",
      GET_CONFIGURATION_INFO_LIMIT_LOG: "/payment/admin/configuration/info/limit/log",
      GET_CONFIGURATION_INFO_FEE_LOG: "/payment/admin/configuration/info/fee/log",
      GET_CONFIGURATION_INFO_PG_LOG: "/payment/admin/configuration/info/pg/log",
      GET_CONFIGURATION_INFO_CONFIG_LOG: "/payment/admin/configuration/info/config/log",
      GET_PREPAID_CARD_INFO_LOG: "/payment/admin/configuration/info/prepaid/log",
      INVENTORY_LIST: "/payment/api/inventory/upload/listing",
      SETTLEMENT_REPORT: "/reporting-service/report/settlement",
      EXPENSE_REPORT: "/reporting-service/report/expense",
      OUTSTANDING_WALLET_BALANCE_REPORT: "/reporting-service/report/wallet/outstandings",
      INCOME_REPORT: "/reporting-service/report/income",
      ESCROW_REPORT: "/reporting-service/report/escrow/balance",
      HIERARCHY_REPORTS: "/user-service/admin/merchant/detail/datalisting",
      CARD_ISSUE_REPORT: "/reporting-service/report/card/issue",
      RETRY_VA_ACCOUNT: "/payment/bank/retry-create-virtual-account",
      ADD_FAQ: "/user-service/admin/faq/add",
      UPDATE_FAQ: "/user-service/admin/faq/update",
      FETCH_FAQ: "/user-service/admin/faq/fetchAll",
      FETCH_FAQ_TOPICS: "/user-service/admin/faq/fetch/topics",
      ADD_FAQ_TOPICS: "/user-service/admin/faq/add/topics",
      FETCH_FAQ_BY_USER_TYPE: "/user-service/admin/faq/fetch/by",
      FETCH_FAQ_BY_TOPIC: "/user-service/admin/faq/fetchBy/topic",
      EDIT_FAQ: "/user-service/admin/faq/fetch",
      DELETE_FAQ: "/user-service/admin/faq/delete",
      PHYSICAL_UPLOAD_KIT: "/payment/admin/prepaid/card/upload/physical/kit",
      PHYSICAL_CSV_UPLOAD_KIT:"/payment/admin/prepaid/card/upload/v1/physical/kit",
      VIEW_PHYSICAL_KIT: "/payment/admin/prepaid/card/view/physical/kit",
      DISPATCH_PHYSICAL_KIT: "/payment/admin/prepaid/card/dispatch/physical/kit",
      VIRTUAL_UPLOAD_KIT: "/payment/admin/prepaid/card/upload/virtual/kit",
      VIEW_VIRTUAL_KIT: "/payment/admin/prepaid/card/view/virtual/kit",
      CREATE_OPERATOR: "/payment/api/operator/create",
      UPDATE_OPERATOR: "/payment/api/operator/update",
      FETCH_OPERATOR: "/payment/api/operator/fetchAll",
      FETCH_OPERATOR_DETAIL: "/payment/api/operator/fetch",
      DELETE_OPERATOR: "/payment/api/operator/delete",
      CARD_PRODUCT: "/payment/admin/prepaid/card/product",
      DOWNLOAD_INVENTORY:"/payment/api/inventory/download",

      VIRTUAL_CARD_UPDATE: "/payment/admin/prepaid/card/virtual/change/status",
      PHYSICAL_CARD_UPDATE: "/payment/admin/prepaid/card/physical/change/status",
      PAY_BACK: "/payment/admin/transactions/payBack",
      PAY_BACK_LISTING: "/payment/admin/transactions/payBack/listing",
      PAY_BACK_CREATE_REQUEST: "/payment/payback/request/create",
      PAY_BACK_REQUEST_LIST: "/payment/payback/request/list",
      SEARCH_OPERATOR_BY_SERVICE_TYPE: "/payment/api/operator",
      GET_BALANCE: "/reporting-service/admin/dashboard/balance",

      CREATE_TICKET: "/user-service/admin/ticket/create",
      UPDATE_TICKET: "/user-service/admin/ticket/update",
      TICKET_LIST: "/user-service/admin/ticket/list",
      TICKET_CATEGORY_LIST: "/user-service/admin/ticket/category",
      TICKET_STATUS_LIST: "/user-service/admin/ticket/status",
      TICKET_PRIORITY_LIST: "/user-service/admin/ticket/priority",
      TICKET_REQUESR_TYPE_LIST: "/user-service/admin/ticket/request-type",
      // USER_ACCOUNT_LIST: "/payment/admin/get-user/account/list",
      USER_ACCOUNT_LIST: "/payment/beneficiary/bankDetails/getBeneficiaryListWithCount",
      USER_SELF_LIST: "/payment/user/bank/account",
      USER_VIRTUAL_ACCOUNT: "/payment/admin/get-user/virtual-account/details",
      CHANGE_PASSWORD: "/user-service/admin/account/change-password",
      BLOCK_USER: "/payment/admin/block/user",
      USER_CONFIG_PAYIN: "/user-service/user/config/payIn",
      USER_CONFIG_PAYOUT: "/user-service/user/config/payOut",
      USER_CONFIG_PAYIN_COUNT: "/user-service/user/config/payInCount",
      USER_CONFIG_PAYOUT_COUNT: "/user-service/user/config/payOutCount",
      USER_CONFIG_TXN_COUNT: "/user-service/user/config/perTxnLimit",
      USER_CONFIG_LIST: "/user-service/user/config",
      USER_CONFIG_DASHBOARD: "/user-service/user/config/dashboard",
      USER_CONFIG_PAYMENT_MODE: "/user-service/user/config/paymentMode",
      DELETE_USER_CONFIG_PAYOUT_LIMIT: "/user-service/user/config/delete",
      CPV_ADMIN_ACTION:"/user-service/user/vkyc/cpv-admin-action",

      BANNER_LIST: "/user-service/banner/details",
      BANNER_LIST_NEW: "/user-service/notification/banner/history",
      ADD_BANNER: "/user-service/notification/banner/create",
      BANNER_UPDATE: "/user-service/notification/banner/update",
      DELETE_BANNER: "/user-service/notification/banner/delete",
      CREATE_BANNER: "/user-service/banner/upload",
      UPDATE_BANNER: "/user-service/banner/update",
      BANNER_DELETE: "/user-service/banner/delete",
      DEFAULT_USER_CONFIG_TXN_COUNT: "/user-service/user/default/config/perTxnLimit",
      DEFAULT_USER_CONFIG_PAYIN: "/user-service/user/default/config/payIn",
      DEFAULT_USER_CONFIG_PAYOUT: "/user-service/user/default/config/payOut",
      DEFAULT_USER_CONFIG_PAYIN_COUNT: "/user-service/user/default/config/payInCount",
      DEFAULT_USER_CONFIG_PAYOUT_COUNT: "/user-service/user/default/config/payOutCount",
      DEFAULT_USER_CONFIG_LIST: "/user-service/user/default/config",
      DEFAULT_USER_CONFIG_DASHBOARD: "/user-service/user/default/config/dashboard",
      FETCH_PREPAID_CARD_DETAILS: "/payment/admin/get-user/prepaid/card/details",
      FETCH_NCMC_PREPAID_CARD_DETAILS: "/payment/admin/get-user/prepaid/card/details/v1",
      FETCH_OSA_PREPAID_CARD_DETAILS: "/payment/prepaid/card/API/v1/osa-creation/list",
      ISSUED_PREPAID_CARD: "/reporting-service/admin/view/issued/prepaid/card",
      MCC_CONFIGURATION_LIST: "/payment/admin/configuration/mcc/details/list",
      MCC_DETAIL_UPDATE: "/payment/admin/configuration/mcc/details/update",
      ADD_MCC_DETAIL: "/payment/admin/configuration/mcc/details/add",
      ORDER_LIST: "/payment/admin/prepaid/card/order/list",
      BOX_ORDER_LIST:"/payment/admin/soundbox/order/list",
      ORDER_STATUS_UPDATE: "/payment/admin/prepaid/card/order/update/status",
      BOX_ORDER_STATUS_UPDATE: "/payment/admin/soundbox/order/update/status",
      FETCH_BBPS_BALANCE: "/reporting-service/admin/dashboard/bbps/balance",
      VPA_GENERATE: "/user-service/admin/generate/vpa",
      VPA_FETCH_LIST: "/user-service/admin/fetch/vpa/list",
      RETRY_VPA_ACCOUNT: "/user-service/admin/update/user/vpa/id",
      VPA_FETCH_DETAILS: "/user-service/admin/fetch/vpa/details",
      FETCH_USER_TICKET_LIST: "/user-service/admin/fetch/user/ticket",
      ADD_COMMISSION_SETTING: "/payment/user/payment/update/service/charge/configuration",
      COMMISSION_SETTING_LIST: "/payment/user/payment/fetch/all/service/charge/configuration",
      UPDATE_CARD_STATUS: "/payment/admin/prepaid/card/change/status",
      TRANSACTION_VALIDATE: "/payment/transaction/validate",
      REPORT_BY_TRANSACTION: "/reporting-service/report/by/transaction/type",
      ORG_TRANSACTION_REPORT: "/reporting-service/admin/transaction/org-inward",
      ORG_SETTELEMENT_REPORT: "/reporting-service/admin/transaction/org-inward/settlement",
      UPI_REPORTS: "/reporting-service/admin/transaction/upi",
      HOLD_BALENCE_REPORTS: "/reporting-service/report/holdbalance",
      ORG_HOLD_BALENCE_REPORTS: "/payment/partner/hold-balance/list",
      RELEASE_HOLD_BALANCE: "/payment/payment/release/hold/amount",
      APPROVE_EMAIL_REPORTS: "/user-service/admin/email-approval-list",
      APPROVE_REJECT: "/user-service/admin/approve-email-update",
      DAILY_REPORT: "/reporting-service/merchant/daily/report",
      DOWNLOAD_REPORT: "/reporting-service/merchant/daily/report/download",
      ESCROW_TRANSACTION_LIST: "/payment/transaction/statement/escrow",
      ADD_APPROVAL_USER: "/payment/admin/approval/user/add",
      APPROVAL_USER_LIST: "/payment/admin/approval/user/list",
      APPROVAL_USER_DETAIL: "/payment/admin/approval/user/by/id",
      APPROVAL_USER_UPDATE: "/payment/admin/approval/user/update",
      RECONCILE_COLLECT_LIST: "/payment/reconcile/collect/request/list",
      RECONCILE_COLLECT_ADD: "/payment/reconcile/collect/request/add",
      RECONCILE_COLLECT_APPROVED: "/payment/reconcile/collect/request/approve",
      UPLOAD_MCC_FILE_UPLOAD: "/payment/admin/configuration/mcc/upload",
      USER_DETAILS: "/payment/beneficiary/bankDetails/getSelfAndBeneficiaryUserDetails",
      MPIN_RESTRICTION_STATUS:"/payment/admin/transactions/mpin-restriction/status",
      RESET_MPIN_RESTRICTION:"/payment/admin/transactions/reset-mpin-restriction",
      BENEFICIARY_LIST: "/api-service/bank/org/beneficiaries/",
      ADD_BENEFICIARY: "/api-service/bank/org-beneficiary/add",
      UPDATE_BENEFICIARY_STATUS: "/api-service/bank/org-beneficiary/status/update",
    },
    user: {
      GET_ROLES: "/user-service/manage/user/role",
      GET_PERMISSIONS: "/user-service/manage/user/permission",
      UPDATE_PERMISSIONS: "/user-service/manage/user/update-permission",
      ADD_USER: "/user-service/admin/create-user",
      All_PERMISSIONS: "/user-service/manage/user/all-permission",
      UPDATE_USER: "https://jsonplaceholder.typicode.com/users",
      LOGOUT_USER: "https://jsonplaceholder.typicode.com/users",
      GET_PROFILE: "/user-service/user/profile",
      FETCH_USER_DETAILS: "/user-service/admin/fetch/user",
      FETCH_KYC_DETIALS: "/user-service/admin/fetch/user/kyc",
      VKYC_LIST:"/user-service/admin/vkyc/list",
      VKYC_DOWNLOAD:"/user-service/admin/vkyc/download",
      FORM60_LIST:"/user-service/dtc/orange-card/form60/list",
      FORM60_ACTION:"/user-service/dtc/orange-card/form60/action",
      FORM60_VIEW:"/user-service/dtc/orange-card/form60/view",
      UPLOAD_KYC: "/user-service/admin/upload/user/kyc",
      REJECT_KYC: "/user-service/admin/reject/user/kyc",
      UPDATE_USER_DETAILS: "/user-service/admin/update/user/details",
      UPGRADE_MIN_KYC: "/user-service/admin/upgrade/user",
      BLOCK_PAY_IN: "/user-service/user/config/blockPayIn",
      BLOCK_PAY_OUT: "/user-service/user/config/blockPayOut",
      DEFAULT_BLOCK_PAY_IN: "/user-service/user/default/config/blockPayIn",
      DEFAULT_BLOCK_PAY_OUT: "/user-service/user/default/config/blockPayOut",
      USER_BY_MOBILE: "/user-service/user/search/by-mobile",
      GET_NOTIFICATION: "/user-service/user/notification/history",
      UPDATE_NOTIFICATION_STATUS: "/user-service/user/notification/status",
      DOWNLOAD_USER_LIST: "/user-service/user/notification/csv",
      LOGIN_HISTORY: "/user-service/admin/login/logs/details",
      GET_NOTIFICATION_COUNTS: "/user-service/user/notification/counts",
      SOUND_BOX: "/user-service/admin/fetch/user/soundbox",
      UPDATE_SOUND_BOX: "/user-service/admin/update/user/soundbox",
      // MCC API's
      MCC_GROUPS: "/user-service/v2/mcc/industries",
      MCC_SUB_CATEGORY: "/user-service/v2/mcc/subcategories",
      MCC_DETAILS: "/user-service/v2/mcc/details",
      ADD_NEW_MCC: "/user-service/v2/mcc/sub-category",
      GET_DETAILS_BY_HSN: "/user-service/v2/mcc/by-hsn",
      GET_DETAILS_BY_NIC: "/user-service/v2/mcc/by-nic",
      GET_MCC_DATA_BY_MCC_CODE: "/user-service/mcc/mcc-detail",
      GET_MCC_CODE_BY_INDUSTRY: "/user-service/mcc/mcc_code",
      UPDATE_SUB_CATEGORY: "/user-service/mcc/subcategory/save",
      UPDATE_USER_MCC_CODE: "/user-service/user/p2m/kyc/verify-mcc",
      MCC_LIST: "/user-service/v2/mcc/list-by-type",
      UPLOAD_MCC_CSV: "/user-service/v2/mcc/upload-csv",
      UPDATE_RISK_TYPE: "/user-service/admin/update",
      FRAUD_RISK_HISTORY: "/user-service/admin/fraud-risk/history",
      MAINTENANCE_CREATE: "/user-service/maintenance/create",
      MAINTENANCE_GET_ALL: "/user-service/maintenance/get-all",
      MAINTENANCE_UPDATE: "/user-service/maintenance/update",
      FETCH_MANDATES: "/payment/v1/LMS/Mandates/fetch-mandates",
      REVOKE_MANDATE_LIST: "/payment/v1/LMS/Mandates/revoke-request/list",
      MANDATE_DUES: "/payment/v1/LMS/Mandates/mandate-dues",
      ACTION_REVOKE_MANDATE: "/payment/v1/LMS/Mandates/revoke-request/action",
      UPDATE_MANDATE_STATUS: "/payment/admin-mandates/update-status",
    },
    distributer: {
      GET_AGENTS: "/user-service/distributor/get/agent/list",
      SUBMIT_AADHAR_OTP: "/user-service/agent/submit-aadhar-otp",
      GET_AADHAR_OTP: "/user-service/agent/get-aadhar-otp",
      VERIFY_PAN: "/user-service/agent/verify-pan",
      DISTRIBUTOR_DASHBOARD_DETAILS: "/user-service/distributor/dashboard/details",
      AGENT_DETAILS: "/reporting-service/distributor/agent/details",
      TRANSACTION_DETAILS: "/reporting-service/distributor/dashboard/transaction/details",
    },
    accessManagement: {
      GET_ALL_PERMISSIONS: "/user-service/admin/permission/v1/get-all", // For fetching all (paginated/filtered)
      CREATE_PERMISSION: "/user-service/admin/permission/v1/create",
      EDIT_PERMISSION: "/user-service/admin/permission/v1/edit",
      TOGGLE_PERMISSION_STATUS_BASE: "/user-service/admin/permission/v1",
      GET_ALL_ROLES: "/user-service/admin/role/v1/get-all",
      CREATE_ROLES: "/user-service/admin/role/v1/create",
      EDIT_ROLE: "/user-service/admin/role/v1/edit",
      ROLE_DATA_WITH_PERMISSION: "/user-service/admin/role/v1/get-permissions",
      ADD_REMOVE_PERMISSION_TO_ROLE: "/user-service/admin/role/v1/permissions/update",
      GET_DROPDOWN_DETAILS: "/user-service/admin/role/v1/dropdowns",
    },
    societyPartnerHub: {
      GET_ALL_SOCIETIES: "/user-service/partner/get-society",
      ALL_USERS: "/user-service/partner/get-users",
      USER_TRANSACTIONS: "/payment/partner/txn/listing",
      LEDGER_LIST: "/payment/partner/prefund-ledger",
      SETTLEMENT_LIST: "/payment/partner/settlement",
      BALANCE: "/payment/partner/prefund-bal",
      PER_SETTLEMENT_TXN: "/payment/partner/settled/txn",
      ACC_DETAILS: "/payment/partner/account",
      LEDGER_DETAILS: "/payment/partner/ledger",
      PARTNER_DASHBOARD_SUMMARY: "/payment/partner/dashboard-summary",
      MAIN_WALLET_BALANCE:"/payment/wallet-details/main-wallet-balance",
    },
    cardManagement: {
      ADD_CARD_PRODUCT: "/payment/admin/prepaid/card/add/card-product",
      LIST_CARD_PRODUCTS: "/payment/admin/prepaid/card/list/card-product",
      MARK_CARD_PRODUCT_DEFAULT: "/payment/admin/prepaid/card/mark/card-product-default",
      LIST_ORG_CARDS: "/payment/admin/prepaid/card/list/org-card",
      ADD_ORG_CARD_MAPPING: "/payment/admin/prepaid/card/map/org-card",
      VIEW_CARD_PRODUCT_DETAILS: "/payment/admin/prepaid/card/get/org-card",
    },
    InventoryManagement: {
      GET_QR_REQUEST_LIST: "/payment/api/vpa/listing-qr-request",
      CREATE_QR_REQUEST: "/payment/api/vpa/qr-request",
      GET_INVENTORY_LIST: "/payment/api/vpa/listing-inventory",
      VPA_ALLOTMENT: "/payment/api/vpa/allotment-by-admin",
      UPLOAD_SOUNDBOX_INVENTORY: "/payment/api/sound-box/device-bulk-upload",
      SOUNDBOX_INVENTORY_LIST: "/payment/api/sound-box/listing-inventory",
      DEALLOCATE_SOUNDBOX: "/payment/api/sound-box/in-active-device",
      SOUNDBOX_ASSIGNED_LIST: "/payment/api/sound-box/listing-assigned",
      ALLOCATE_SOUNDBOX: "/payment/api/sound-box/assign-by-admin",
    },
  },
};
